import React, { Component } from 'react';

class ContinueLoginModal extends Component {
  render() {
    const { onClickYes } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="continueLoginModal"
        tabIndex="-1"
        aria-labelledby="continueLoginModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="continueLoginModalLabel">Local Changes</h5>
              <p>{`Another user on this device has unsaved changes. When you login with a different account,
                the previous user's data will be lost. Would you like to continue logging in?`}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                  >No
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onClickYes()}
                  >Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContinueLoginModal;
